export function getServerUrl(token: string | null | undefined) {
  const url = process.env.NEXT_PUBLIC_LIVEKIT_URL;
  if (!token) {
    return url;
  }

  return url.replace("wss://", "https://").replace("ws://", "http://");
}
